var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check_box_outline_blank - material") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FINAL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filtre2",
    transform: "translate(-478.000000, -127.000000)",
    fill: "#D0D1DA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(469.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.611,73.775 C24.0870024,73.775 24.4999983,73.9499982 24.85,74.3 C25.2000018,74.6500018 25.375,75.0629976 25.375,75.539 L25.375,87.761 C25.375,88.2370024 25.2000018,88.6499982 24.85,89 C24.4999983,89.3500018 24.0870024,89.525 23.611,89.525 L11.389,89.525 C10.9129976,89.525 10.5000018,89.3500018 10.15,89 C9.79999825,88.6499982 9.625,88.2370024 9.625,87.761 L9.625,75.539 C9.625,75.0629976 9.79999825,74.6500018 10.15,74.3 C10.5000018,73.9499982 10.9129976,73.775 11.389,73.775 L23.611,73.775 Z M23.611,75.539 L11.389,75.539 L11.389,87.761 L23.611,87.761 L23.611,75.539 Z",
    id: "check_box_outline_blank---material"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.c564634263414ab2699e2e1432a275d4.svg";
export { ForwardRef as ReactComponent };